import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'VM',
  name: 'Valeria M.',
  location: 'Buenos Aires',
  quote: 'Me levanté el lunes sin panza. No lo podía creer. El Protocolo de Vaciado lo hice el domingo a la noche y al otro día el jean me cerró sin problema.'
}, {
  initials: 'CP',
  name: 'Carolina P.',
  location: 'Córdoba',
  quote: 'Siempre pensé que era de panza sensible. El Tomo 2 me mostró que era mi alacena. Cambié 5 cosas y en una semana era otra persona.'
}, {
  initials: 'RS',
  name: 'Romina S.',
  location: 'Rosario',
  quote: 'El Botiquín de Infusiones es oro puro. Por fin sé qué tomar según lo que siento.'
}];
export function TestimoniosQuick() {
  return <section className="py-12 bg-black px-4 border-t border-white/5 pt-[4px] pb-[4px]" data-id="element-272">
      <div className="max-w-6xl mx-auto" data-id="element-273">
        <p className="text-sm font-bold text-gray-500 tracking-widest uppercase mb-8" data-id="element-274">
          Testimonios
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-275">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10 flex flex-col items-center" data-id="element-276">
              <div className="flex gap-1 mb-3 text-yellow-400 justify-center" data-id="element-277">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-278" />)}
              </div>
              <p className="text-gray-300 italic mb-4 text-sm leading-relaxed" data-id="element-279">
                "{t.quote}"
              </p>
              <div className="flex flex-col items-center gap-2 mt-auto" data-id="element-280">
                <div className="w-12 h-12 rounded-full bg-brand-green text-white flex items-center justify-center font-bold" data-id="element-281">
                  {t.initials}
                </div>
                <div data-id="element-282">
                  <p className="font-bold text-sm text-white" data-id="element-283">{t.name}</p>
                  <p className="text-xs text-gray-400" data-id="element-284">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}